<template>
  <AuthLayout :mode="mode">
    <ManufacturersActions type="add" :mode="mode" />
  </AuthLayout>
</template>

<script>
import ManufacturersActions from "@C/ManufacturersActions.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "AddManufacturer",
  components: {
    AuthLayout,
    ManufacturersActions,
  },
  props: {
    mode: String,
  },
};
</script>
